<template>
  <fragment>
    <div class="row" v-if="entity.isHistory">
      <div class="col-12">
        <ul class="list-inline mb-0">
          <li class="list-inline-item">
            <h4 class="page-title">
              <i class="feather icon-clock"></i>
              {{ entity.updateDate | formatFullNameDate }}
            </h4>
          </li>
          <li class="list-inline-item float-right">
            <button
              title="Chiudi anteprima"
              class="btn btn-link"
              @click="close"
            >
              <i class="feather icon-x font-20"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-10">
        <h3 class="page-title text-primary mb-2">
          {{ entity.state | contractState }}

          <button
            type="button"
            class="btn btn-xs btn-danger ml-5 right"
            @click="stopped"
            v-if="
              !entity.isHistory &&
              isInRole('superoperator') &&
              !entity.new &&
              entity.state != 'Stopped' &&
              !entity.isHistory
            "
          >
            REVOCA PRATICA
            <font-awesome-icon
              class="ml-2"
              :icon="['far', 'times-circle']"
            ></font-awesome-icon>
          </button>
          <button
            type="button"
            class="btn btn-xs btn-warning ml-5 right"
            @click="backward"
            v-if="
              !entity.isHistory &&
              isInRole('superoperator') &&
              entity.previousStates.length > 0 &&
              !entity.new &&
              entity.state != 'Stopped' &&
              !entity.isHistory
            "
          >
            RETROCEDI

            <font-awesome-icon
              class="ml-2"
              :icon="['fas', 'backward']"
            ></font-awesome-icon>
          </button>

          <button
            type="button"
            class="btn btn-xs btn-success ml-5 right"
            @click="reopen"
            v-if="
              isInRole('superoperator') &&
              entity.state == 'Stopped' &&
              !entity.isHistory
            "
          >
            RIAPERTURA PRATICA
            <font-awesome-icon
              class="ml-2"
              :icon="['far', 'check-circle']"
            ></font-awesome-icon>
          </button>
        </h3>
      </div>
      <div class="col-2 text-right" v-if="entity.company">
        <span class="badge p-2">
          <img
            class="img-fluid"
            :src="`assets/images/logo/${entity.companyId}.svg`"
          />
        </span>
      </div>
      <div v-if="entity.state == 'Stopped'" class="col-12 alert alert-light">
        Annullata in data
        <strong>{{ entity.stoppedDate | formatFullDate }}</strong>
        <p
          v-html="
            '<strong>Note:</strong> ' +
            entity.stoppedNote.split('\n').join('<br />')
          "
        ></p>
      </div>
      <div
        class="col-12"
        v-if="
          flow.errors.length > 0 &&
          !entity.isHistory &&
          !isInRole('customer') &&
          !isInRole('readonly')
        "
      >
        <div class="alert alert-warning" role="alert">
          <h4 class="alert-heading">Attenzione, verifica:</h4>
          <ul class="list-unstyled">
            <li
              v-for="error in flow.errors"
              v-bind:key="error"
              v-if="error != 'attachments'"
            >
              {{ error | contractFields }}
            </li>
            <li
              v-for="error in flow.errors"
              v-bind:key="error"
              v-if="error == 'attachments'"
            >
              Di caricare almeno un file di tipo
              <span v-for="a in flow.attachments" class="mr-1">{{
                attachemntTypes[a]
              }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="form-group">
          <ValidationProvider v-slot="{ classes, errors }" immediate slim>
            <label class="col-form-label d-block" for="importance"
              >Urgenza</label
            >
            <select
              class="form-control"
              v-model="entity.importance"
              v-if="
                actionEnable('Importance') && !readOnlyControl('Importance')
              "
              :disabled="entity.isHistory"
            >
              <option value="None">Nessuna</option>
              <option value="Low">Gialla</option>
              <option value="Medium">Arancione</option>
              <option value="High">Rossa</option>
            </select>
            <h3
              class="badge badge-light"
              v-if="
                entity.importance == 'None' &&
                (!actionEnable('Importance') || readOnlyControl('Importance'))
              "
            >
              Nessuna urgenza
            </h3>
            <h3
              class="badge badge-danger"
              v-if="
                entity.importance == 'High' &&
                (!actionEnable('Importance') || readOnlyControl('Importance'))
              "
            >
              ROSSA
            </h3>
            <h3
              class="badge badge-warning"
              v-if="
                entity.importance == 'Medium' &&
                (!actionEnable('Importance') || readOnlyControl('Importance'))
              "
            >
              ARANCIONE
            </h3>
            <h3
              class="badge badge-yellow"
              v-if="
                entity.importance == 'Low' &&
                (!actionEnable('Importance') || readOnlyControl('Importance'))
              "
            >
              GIALLA
            </h3>
          </ValidationProvider>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <ValidationProvider v-slot="{ classes, errors }" immediate slim>
            <label class="col-form-label" for="releaseDate"
              >Da evadere entro</label
            >
            <p class="form-control" v-if="!actionEnable('Importance')">
              {{ entity.releaseDate | formatNameDate }}
            </p>
            <b-form-datepicker
              v-if="actionEnable('Importance')"
              :readonly="!actionEnable('Importance')"
              :show-decade-nav="true"
              placeholder="Nessuna data selezionata"
              v-model="entity.releaseDate"
              id="example-datepicker"
              class="mb-2"
              :reset-button="true"
              label-reset-button="Nessuna data"
              reset-button-variant="btn-xs btn-danger-rgba"
            ></b-form-datepicker>
          </ValidationProvider>
        </div>
      </div>
      <div class="col-5">
        <div class="form-group">
          <ValidationProvider v-slot="{ classes, errors }" immediate slim>
            <label class="col-form-label" for="inchargeTo">Operatore</label>
            <select
              name="inchargeTo"
              class="form-control"
              v-model="entity.inChargeTo"
              v-if="
                (actionEnable('ChoiceCommercialOperator') ||
                  actionEnable('ChoiceOperator')) &&
                !readOnlyControl('inchargeTo') &&
                !entity.isHistory
              "
            >
              <option :value="null">Nessun operatore</option>
              <option
                v-if="operators"
                v-for="option in operators"
                v-bind:key="option.userId"
                v-bind:value="option.userId"
              >
                {{ option.firstName }} {{ option.lastName }}
              </option>
            </select>
            <p
              v-if="
                (entity.operator != null) &&
                (entity.isHistory ||
                  (!actionEnable('ChoiceCommercialOperator') &&
                    !actionEnable('ChoiceOperator')) ||
                  readOnlyControl('inchargeTo'))
              "
            >
              {{ entity.operator.firstName }}
              {{ entity.operator.lastName }}
            </p>
          </ValidationProvider>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        <div class="form-group">
          <label class="col-form-label" for="outsourcerId">Outsourcer</label>
          <select
            name="outsourcerId"
            class="form-control"
            v-model="entity.outSourcerId"
            :disabled="
              readOnlyControlSO('outsourcer') ||
              isInRole('user') ||
              entity.isHistory
            "
          >
            <option :value="null">Nessun outsourcer</option>
            <option
              v-for="option in outsourcers"
              v-bind:key="option.userId"
              v-bind:value="option.userId"
            >
              {{ option.firstName }} {{ option.lastName }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label class="col-form-label" for="externalCode">Numero Ordine</label>
          <input
            type="text"
            class="form-control"
            :disabled="
              readOnlyControl('externalCode') ||
              isInRole('user') ||
              entity.isHistory
            "
            id="externalCode"
            name="externalCode"
            v-model="entity.externalCode"
          />
        </div>
      </div>
      <div class="col-4" v-if="entity.procedureId == 'procura'">
        <div class="form-group">
          <label class="col-form-label" for="NotaryExternalCode"
            >N. pratica gestionale notarile</label
          >
          <input
            type="text"
            class="form-control"
            :disabled="
              readOnlyControl('NotaryExternalCode') ||
              isInRole('user') ||
              entity.isHistory
            "
            id="NotaryExternalCode"
            name="NotaryExternalCode"
            v-model="entity.notaryExternalCode"
          />
        </div>
      </div>
      <div class="col-8">
        <div class="form-group">
          <ValidationProvider
            v-slot="{ classes, errors }"
            immediate
            slim
            :rules="{ regex: regexPattern }"
          >
            <label class="col-form-label" for="code">Codice Contratto</label>
            <input
              type="text"
              class="form-control required"
              :disabled="
                readOnlyControl('Code') ||
                entity.isHistory ||
                entity.parentContractId
              "
              id="code"
              name="code"
              :placeholder="entity.company.contractPlaceHolder"
              v-model="entity.code"
              :class="classes"
              @change="verifyCode"
            />
          </ValidationProvider>
        </div>
      </div>
      
      <div class="col-2" v-if="!hideControl('IsPartial')">
        <div class="form-group">
          <label class="col-form-label" for="IsPartial">Parziale</label>
          <select
            class="form-control"
            v-model="entity.isPartial"
            :disabled="readOnlyControl('IsPartial') || entity.isHistory"
          >
            <option :value="true">SI</option>
            <option :value="false">NO</option>
          </select>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label class="col-form-label" for="taxation">Fiscalità</label>
          <select
            name="taxation"
            class="form-control"
            v-model="entity.taxation"
            :disabled="readOnlyControl('taxation') || entity.isHistory"
          >
            <option value="none">Ancora da definire</option>
            <option value="iva">Iva</option>
            <option value="reverse-charge">Reverse Charge</option>
            <option value="esente-iva">Esente Iva</option>
            <option value="split-payment">Split Payment</option>
          </select>
        </div>
      </div>
      <div class="col-10" v-if="!hideControl('Amount')">
        <div class="form-group">
          <ValidationProvider v-slot="{ classes, errors }" immediate slim>
            <label class="col-form-label" for="Amount"
              >Valore di riscatto</label
            >
            <currency-input
              v-model="entity.amount"
              class="form-control required"
              :disabled="readOnlyControlSO('Amount') || entity.isHistory"
            />
          </ValidationProvider>
        </div>
      </div>
      <div class="col-2" v-if="!hideControl('Amount')">
        <div class="form-group">
          <label class="col-form-label" for="RansomPayment"
            >Pagamento riscatto</label
          >
          <select
            class="form-control"
            v-model="entity.ransomPayment"
            :disabled="readOnlyControlSO('Amount') || entity.isHistory"
          >
            <option :value="true">SI</option>
            <option :value="false">NO</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="form-group">
          <label class="col-form-label" for="name">Tipo procedura</label>
          <select
            v-model="entity.procedureId"
            class="form-control"
            @change="changeProcedure"
            :disabled="readOnlyControl('ProcedureId') || entity.isHistory"
          >
            <option
              v-for="option in procedures"
              v-bind:key="option.procedureId"
              v-bind:value="option.procedureId"
            >
              {{ option.description }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label class="col-form-label" for="ransomId"
            >Tipologia riscatto</label
          >
          <select
            v-model="entity.ransomId"
            class="form-control"
            @change="ransomChange"
            :disabled="
              readOnlyControl('ProcedureId') ||
              entity.isHistory ||
              entity.parentContractId
            "
          >
            <option
              v-for="option in ransoms"
              v-bind:key="option.ransomId"
              v-bind:value="option.ransomId"
            >
              {{ option.description }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label class="col-form-label" for="subRansomId"
            >Sotto tipologia riscatto</label
          >
          <i class="text-muted form-control" v-if="subRansoms.length == 0"
            >Nessuna selezione</i
          >
          <select
            v-model="entity.subRansomId"
            id="subRansomId"
            class="form-control"
            :disabled="
              readOnlyControl('ProcedureId') ||
              subRansoms.length == 0 ||
              entity.isHistory
            "
            v-if="subRansoms.length > 0"
          >
            <option
              v-for="option in subRansoms"
              v-bind:key="option.subRansomId"
              v-bind:value="option.subRansomId"
            >
              {{ option.description }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-5" v-if="!hideControl('CreditAmount')">
        <div class="form-group">
          <ValidationProvider v-slot="{ classes, errors }" immediate slim>
            <label class="col-form-label" for="CreditAmount"
              >Importo del credito</label
            >
            <currency-input
              v-model="entity.creditAmount"
              class="form-control"
              :disabled="readOnlyControlSO('CreditAmount') || entity.isHistory"
            />
          </ValidationProvider>
        </div>
      </div>
        <div class="col-3" v-if="!hideControl('ResolutionAcquired')">
        <div class="form-group">
          <label class="col-form-label" for="ResolutionAcquired"
            >Acquisizione Delibera</label
          >
          <select
            class="form-control"
            v-model="entity.resolutionAcquired"
            :disabled="
              readOnlyControl('ResolutionAcquired') || entity.isHistory
            "
          >
            <option :value="true">SI</option>
            <option :value="false">NO</option>
          </select>
        </div>
      </div>
      <div class="col-4" v-if="!hideControl('ExpirationDate')">
        <div class="form-group">
          <ValidationProvider v-slot="{ classes, errors }" immediate slim>
            <label class="col-form-label" for="code">Data scadenza </label>
            <p
              class="form-control"
              v-if="readOnlyControl('ExpirationDate') || entity.isHistory"
            >
              {{ entity.expirationDate | formatNameDate }}
            </p>
            <b-form-datepicker
              v-if="!readOnlyControl('ExpirationDate') && !entity.isHistory"
              :readonly="readOnlyControl('ExpirationDate') || entity.isHistory"
              :show-decade-nav="true"
              placeholder="Nessuna data selezionata"
              v-model="entity.expirationDate"
              id="ExpirationDate"
              class="mb-2"
              :reset-button="true"
              label-reset-button="Nessuna data selezionata"
              reset-button-variant="btn-xs btn-danger-rgba"
            ></b-form-datepicker>
          </ValidationProvider>
        </div>
      </div>
      <div class="col-4" v-if="!hideControl('CreditDate')">
        <div class="form-group">
          <ValidationProvider v-slot="{ classes, errors }" immediate slim>
            <label class="col-form-label" for="code">Data del credito </label>
            <p
              class="form-control"
              v-if="readOnlyControl('CreditDate') || entity.isHistory"
            >
              {{ entity.creditDate | formatNameDate }}
            </p>
            <b-form-datepicker
              v-if="!readOnlyControl('CreditDate') && !entity.isHistory"
              :readonly="readOnlyControl('CreditDate') || entity.isHistory"
              :show-decade-nav="true"
              placeholder="Nessuna data selezionata"
              v-model="entity.creditDate"
              id="CreditDate"
              class="mb-2"
              :reset-button="true"
              label-reset-button="Nessuna data selezionata"
              reset-button-variant="btn-xs btn-danger-rgba"
            ></b-form-datepicker>
          </ValidationProvider>
        </div>
      </div>

      <div class="col-4" v-if="!hideControl('StipulationDate')">
        <div class="form-group">
          <ValidationProvider v-slot="{ classes, errors }" immediate slim>
            <label class="col-form-label" for="code"
              >Data presunta stipula
            </label>
            <p
              class="form-control"
              v-if="readOnlyControl('StipulationDate') || entity.isHistory"
            >
              {{ entity.stipulationDate | formatFullNameDate }}
            </p>
            <input type="datetime-local"  class="form-control" placeholder="Nessuna data selezionata"   v-model="entity.stipulationDate" v-if="!readOnlyControl('StipulationDate') && !entity.isHistory"
              :readonly="readOnlyControl('StipulationDate') || entity.isHistory" />
           

       
          </ValidationProvider>
        </div>
      </div>
      <div class="col-4" v-if="!hideControl('ReleaseDate')">
        <div class="form-group">
          <ValidationProvider v-slot="{ classes, errors }" immediate slim>
            <label class="col-form-label" for="ReleaseDate"
              >Data di stipula</label
            >

            <p
              class="form-control"
              v-if="readOnlyControl('ReleaseDate') || entity.isHistory"
            >
              {{ entity.releaseDate | formatNameDate }}
            </p>
            <b-form-datepicker
              :readonly="readOnlyControl('ReleaseDate') || entity.isHistory"
              :show-decade-nav="true"
              placeholder="Nessuna data selezionata"
              v-model="entity.releaseDate"
              id="ReleaseDate"
              class="mb-2"
              :reset-button="true"
              label-reset-button="Nessuna data selezionata"
              reset-button-variant="btn-xs btn-danger-rgba"
              v-if="actionEnable('ReleaseDate')"
            ></b-form-datepicker>
          </ValidationProvider>
        </div>
      </div>
      <div class="col-2" v-if="!hideControl('AML')">
        <div class="form-group">
          <label class="col-form-label" for="AML">AML</label>
          <select
            class="form-control"
            v-model="entity.aml"
            :disabled="readOnlyControl('AML') || entity.isHistory"
          >
            <option :value="true">SI</option>
            <option :value="false">NO</option>
          </select>
        </div>
      </div>
      <div class="col-2" v-if="!hideControl('CONT')">
        <div class="form-group">
          <label class="col-form-label" for="cont">Contabile</label>
          <select
            class="form-control"
            v-model="entity.cont"
            :disabled="readOnlyControl('CONT') || entity.isHistory"
          >
            <option :value="true">SI</option>
            <option :value="false">NO</option>
          </select>
        </div>
      </div>
      <div class="col-12"></div>
      <div class="col-6">
        <label class="col-form-label" for="operatorName"
          >Operatore esterno</label
        >
        <select
          class="form-control"
          id="operatorName"
          name="operatorName"
          v-model="entity.operatorName"
          :disabled="
            readOnlyControl('MissingDocumentation') || entity.isHistory
          "
        >
          <option
            :value="eo.externalOperatorId"
            v-for="eo in externalOperators"
          >
            {{ eo.name }}
          </option>
        </select>
      </div>
       <div class="col-6">
        <div class="form-group">
         
            <label class="col-form-label" for="code">Gestore Contenzioso</label>
             <select
            name="taxation"
            class="form-control"
            v-model="entity.litigation"
            :disabled="entity.isHistory"
          >
            <option value="">No contenzioso</option>
            <option :value="item.key" v-bind:key="index" v-for="(item,index) in litigations">{{item.label}}</option>
            
          </select>
        </div>
      </div>
    </div>
    <!--<form @submit.prevent="save" v-if="entity">-->
    <div class="col-12 mt-3">
    
      <h4 class="card-title">
        Societ&agrave;
        <button
          @click="companyDetail = !companyDetail"
          type="button"
          class="btn btn-xs btn-success-rgba p-1"
        >
          <i class="feather icon-plus mr-2" v-if="!companyDetail"></i>
          <i class="feather icon-minus mr-2" v-if="companyDetail"></i>
          dettagli
        </button>
        <small style="font-size:50%" v-if="entity.companyLastProtocol" class="text-muted mr-2 ml-3">Data ultimo protocollo {{entity.companyLastProtocol | formatNameDate}}</small>
       </h4>
      <div class="form-group">
        <ValidationProvider v-slot="{ classes, errors }" immediate slim>
          <label class="col-form-label" for="name">Ragione sociale</label>
          <input
            type="text"
            class="form-control required"
            id="companyName"
            name="companyName"
            placeholder="Ragione sociale"
            v-model="entity.companyName"
            :class="classes"
            :disabled="readOnlyControl('companyName') || entity.isHistory"
          />
        </ValidationProvider>
      </div>
    </div>

    <div class="row" v-if="companyDetail">
      <div class="col-6">
        <div class="form-group">
          <label class="col-form-label" for="vatNumber">Partita IVA</label>
          <input
            type="text"
            class="form-control"
            id="vatNumber"
            name="vatNumber"
            placeholder="Partita IVA"
            maxlength="11"
            v-model="entity.companyVATNumber"
            :disabled="readOnlyControl('companyVATNumber') || entity.isHistory"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="col-form-label" for="fiscalCode">Codice Fiscale</label>
          <input
            type="text"
            class="form-control"
            id="fiscalCode"
            name="fiscalCode"
            placeholder="Codice Fiscale"
            maxlength="16"
            v-model="entity.companyFiscalCode"
            :disabled="readOnlyControl('companyFiscalCode') || entity.isHistory"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="col-form-label" for="rea">R.E.A</label>
          <input
            type="text"
            class="form-control"
            id="rea"
            name="rea"
            placeholder="R.E.A"
            maxlength="200"
            v-model="entity.companyREA"
            :disabled="readOnlyControl('companyREA') || entity.isHistory"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="col-form-label" for="sdi">SDI</label>
          <input
            type="text"
            class="form-control"
            id="sdi"
            name="sdi"
            placeholder="SDI"
            maxlength="200"
            v-model="entity.companySDI"
            :disabled="readOnlyControl('companySDI') || entity.isHistory"
          />
        </div>
      </div>

      <div class="col-6">
        <div class="form-group">
          <label class="col-form-label" for="companyMail">Email</label>
          <input
            type="text"
            class="form-control"
            id="companyMail"
            name="companyMail"
            placeholder="Indirizzo email"
            maxlength="200"
            v-model="entity.companyMail"
            :disabled="readOnlyControl('companyMail') || entity.isHistory"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="col-form-label" for="companyPhone">Telefono</label>
          <input
            type="text"
            class="form-control"
            id="companyPhone"
            name="companyPhone"
            placeholder="Numero telefonico"
            maxlength="200"
            v-model="entity.companyPhone"
            :disabled="readOnlyControl('companyPhone') || entity.isHistory"
          />
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label class="col-form-label" for="address">Indirizzo</label>
          <input
            type="text"
            class="form-control"
            id="address"
            placeholder="Indirizzo"
            v-model="entity.companyAddress"
            :disabled="readOnlyControl('companyAddress') || entity.isHistory"
          />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label class="col-form-label" for="city">Citt&agrave;</label>
          <input
            type="text"
            class="form-control"
            name="city"
            id="city"
            placeholder="Città"
            v-model="entity.capInfo.comune"
            :disabled="readOnlyControl('companyCity') || entity.isHistory"
          />
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label class="col-form-label" for="zipCode">CAP</label>

          <v-select
            :disabled="readOnlyControl('companyZipCode') || entity.isHistory"
            :id="'zipcode'"
            v-model="entity.capInfo"
            :reduce="(c) => c.cap || ''"
            label="cap"
            :filterable="false"
            :options="options"
            @search="onSearch"
            @input="onSelect"
          >
            <template slot="no-options">
              Nessuna localit&agrave; o CAP trovato
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center" v-if="option != null">
                <strong>{{ option.cap }}</strong> - {{ option.comune }}
              </div>
            </template>
          </v-select>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label class="col-form-label" for="district">Provincia</label>
          <input
            type="text"
            class="form-control text-uppercase"
            name="district"
            id="district"
            maxlength="2"
            placeholder="provincia"
            v-model="entity.capInfo.provincia"
            :disabled="readOnlyControl('companyDistrict') || entity.isHistory"
          />
        </div>
      </div>
    </div>
    <div
      class="row mb-2"
      v-if="!hideControl('Documentation') || actionEnable('ChoiceDocument')"
    >
      <div class="col-9">
        <h4 class="card-title">Documentazione necessaria</h4>
        <div
          class="custom-control"
          style="position: static"
          v-for="option in documentations"
          v-bind:key="option.attachemntTypeId"
          v-if="
            !hideControl('Documentation') &&
            checkedDocumentation.indexOf(option.attachmentTypeId) >= 0
          "
        >
          <div class="row mb-2">
            <div class="col-6 documenti-inline">
              <div  v-if="hasAttachment(option.attachmentTypeId)"
                @click="viewAttachment(option.attachmentTypeId)">
              <label
                class="control-label text-success cursor-pointer"
               
              >
                <i
                  class="feather icon-check-circle text-success document-check"
                ></i>

                {{ option.name }} 
                <i v-if="option.note && option.note != ''">({{ option.note }})</i>
              </label>
              <small v-if="getAttachments(option.attachmentTypeId).length>1" class="d-block ml-5" v-for="att in getAttachments(option.attachmentTypeId)">
                <a href="javascript:void(0)" class="text-primary " @click="downloadAttachment(att.attachmentId, att.originalFileName)">{{att.originalFileName}}</a>

              </small>
              </div>
              <div class="dropzone-custom-content"  v-if="!hasAttachment(option.attachmentTypeId) && readOnlyControl('Documentation')">
                  <label
                    class="control-label text-danger"
                    v-if="!hasAttachment(option.attachmentTypeId)"
                  >
                    <i class="feather icon-circle document-check"></i>
                    {{ option.name }}
                    <i v-if="option.note && option.note != ''">({{ option.note }})</i>
                  </label>
                </div>
              <vue-dropzone
                v-if="!hasAttachment(option.attachmentTypeId) && !readOnlyControl('Documentation')"
                class="customdropzone"
                name="attachment-dropzone"
                :options="dropzoneFileOptions(option.attachmentTypeId)"
                :useCustomSlot="true"
               
              >
                <div class="dropzone-custom-content">
                  <label
                    class="control-label text-danger"
                    v-if="!hasAttachment(option.attachmentTypeId)"
                  >
                    <i class="feather icon-circle document-check"></i>
                    {{ option.name }} 
                    <i v-if="option.note && option.note != ''">({{ option.note }})</i>
                  </label>
                </div>

                <div class="dz-preview dz-file-preview d-none">
                  <div class="dz-progress">
                    <span class="dz-upload" data-dz-uploadprogress></span>
                  </div>
                </div>
              </vue-dropzone>
            </div>
            <div class="col-1">
              <button
                class="btn btn-sm btn-link"
                @click="
                  removeAttachmentType(option.attachmentTypeId, option.name)
                "
                v-if="
                  !entity.isHistory &&
                  entity.state != 'Stopped' &&
                  !hasAttachment(option.attachmentTypeId) &&
                  !hideControl('Documentation') && !readOnlyControl('Documentation') &&
                  !(
                    isInRole('user') ||
                    isInRole('superuser') ||
                    isInRole('customer') ||
                   // isInRole('operator') ||
                    isInRole('readonly')
                  )
                "
              >
                <i class="feather icon-x text-danger" />
              </button>
            </div>

            <div class="col-5">
              <b-form-datepicker
                v-if="
                  entity.documentationDates[option.attachmentTypeId] != null &&
                  entity.procedureId == 'procura'
                "
                :disabled="
                  !actionEnable('UploadAttachment') && readOnlyControl('Documentation')  && 
                  (isInRole('user') ||
                    isInRole('customer') ||  isInRole('commercialoperator') ||
                    isInRole('readonly'))
                "
                :show-decade-nav="true"
                placeholder="Nessuna data selezionata"
                v-model="entity.documentationDates[option.attachmentTypeId]"
                :id="option.attachmentTypeId + '-datepicker'"
                :reset-button="true"
                label-reset-button="Nessuna data"
                reset-button-variant="btn-xs btn-danger-rgba"
              ></b-form-datepicker>
            </div>
          </div>
        </div>
        <div
          class="custom-control"
          style="position: static"
          v-if="hasAttachment('documenti-da-validare')"
        >
          <div class="row mb-2">
            <div class="col-6">
              <label class="control-label text-warning">
                <i class="document-check">{{
                  numAttachment("documenti-da-validare")
                }}</i>

                Documenti da validare
              </label>
            </div>
            <div class="col-6"></div>
          </div>
        </div>
        <div
          class="custom-control custom-checkbox"
          v-for="option in documentations"
          v-bind:key="option.attachemntTypeId"
          v-if="!readOnlyControl('document') &&
            entity.state != 'Stopped' &&
            !hideControl('Documentation') &&
            checkedDocumentation.indexOf(option.attachmentTypeId) < 0 &&
            !(
              isInRole('user') ||
              isInRole('superuser') ||
              isInRole('customer') ||
              isInRole('readonly')
            )
          "
        >
          <input
            type="checkbox"
            :value="option.attachmentTypeId"
            name="documentation"
            class="custom-control-input"
            :id="option.attachmentTypeId"
            v-model="newcheckedDocumentation"
            v-if="!option.system"
          />

          <label
            v-if="!option.system"
            class="custom-control-label"
            :for="option.attachmentTypeId"
            >{{ option.name }} 
            <i v-if="option.note != ''">({{ option.note }})</i>
          </label>
        </div>
        <div
          class="custom-control custom-checkbox"
          v-for="option in documentations.filter(x=> false == !readOnlyControl('document'))"
          v-bind:key="option.attachemntTypeId"
          v-if="
            actionEnable('ChoiceDocument') && !readOnlyControl('document') && 
            !(isInRole('user') || isInRole('superuser') || isInRole('commercialoperator'))
          "
        >
          <input
            type="checkbox"
            :value="option.attachmentTypeId"
            name="documentation"
            class="custom-control-input"
            :id="option.attachmentTypeId"
            v-model="checkedDocumentation"
            v-if="!option.system"
          />
          <label
            class="custom-control-label"
            :for="option.attachmentTypeId"
            v-if="!option.system"
            >{{ option.name }}
            <i v-if="option.note != ''">({{ option.note }})</i>
          </label>
        </div>
      </div>

      <div class="col-3" v-if="!hideControl('MissingDocumentation')">
        <div class="form-group">
          <label class="col-form-label" for="missingDocumentation"
            >Documentazione Carente</label
          >
          <select
            class="form-control"
            v-model="entity.missingDocumentation"
            :disabled="
              readOnlyControl('MissingDocumentation') || entity.isHistory
            "
          >
            <option :value="true">SI</option>
            <option :value="false">NO</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h4 class="card-title">Costi Accessori</h4>
      </div>
      <div class="col-12">
        <table class="table w-100">
          <tr class="row" v-for="cost in entity.costs">
            <td class="col-6">
              <input
                type="text"
                class="form-control"
                placeholder="descrizione costo"
                v-model="cost.description"
                :disabled="entity.isHistory"
              />
            </td>
            <td class="col-2">
              <select
                class="form-control"
                v-model="cost.vatId"
                :disabled="readOnlyControlSO('costs') || entity.isHistory"
              >
                <option :value="v.vatId" v-for="v in vatlist">
                  {{ v.description }}
                </option>
              </select>
            </td>
            <td class="col-2">
              <currency-input
                class="form-control"
                placeholder="Importo netto"
                v-model="cost.amount"
                :disabled="readOnlyControlSO('costs') || entity.isHistory"
              />
            </td>
            <td>
              <button
                class="btn btn-xs btn-danger-rgba"
                @click="removeCost(cost.costId)"
                v-if="!readOnlyControlSO('costs') && !entity.isHistory"
              >
                X
              </button>
            </td>
          </tr>
          <tr
            class="row"
            v-if="!readOnlyControlSO('costs') && !entity.isHistory"
          >
            <td class="col-6">
              <input
                v-model="newCost.description"
                type="text"
                class="form-control"
                placeholder="descrizione costo"
              />
            </td>
            <td class="col-2">
              <select class="form-control" v-model="newCost.vatId">
                <option :value="v.vatId" v-for="v in vatlist">
                  {{ v.description }}
                </option>
              </select>
            </td>
            <td class="col-2">
              <currency-input
                class="form-control"
                v-model="newCost.amount"
                placeholder="Importo netto"
                :disabled="entity.isHistory"
              />
            </td>
            <td>
              <button class="btn btn-xs btn-primary-rgba" @click="addCost">
                +
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h4 class="card-title">Notaio</h4>
      </div>
      <div class="col-3">
        <label class="col-form-label" for="notaryName">Nome</label>
        <input
          type="text"
          class="form-control"
          id="notaryName"
          name="notaryName"
          placeholder="Nome"
          v-model="entity.notaryName"
          :disabled="readOnlyControl('notaryName') || entity.isHistory"
        />
      </div>
      <div class="col-3">
        <label class="col-form-label" for="notarySurname">Cognome</label>
        <input
          type="text"
          class="form-control"
          id="notarySurname"
          name="notarySurname"
          placeholder="Cognome"
          v-model="entity.notarySurname"
          :disabled="readOnlyControl('notarySurname') || entity.isHistory"
        />
      </div>
      <div class="col-3">
        <label class="col-form-label" for="notaryOffice">Sede</label>
        <input
          type="text"
          class="form-control"
          id="notaryOffice"
          name="notaryOffice"
          placeholder="Sede"
          v-model="entity.notaryOffice"
          :disabled="readOnlyControl('notaryOffice') || entity.isHistory"
        />
      </div>
      <div class="col-3">
        <label class="col-form-label" for="notaryEmail">Email</label>
        <input
          type="text"
          class="form-control"
          id="notaryEmail"
          name="notaryEmail"
          placeholder="Email"
          v-model="entity.notaryEmail"
          :disabled="readOnlyControl('notaryEmail') || entity.isHistory"
        />
      </div>
      <div class="col-12">
        <h4 class="card-title">Procuratore</h4>
      </div>
      <div class="col-3">
        <label class="col-form-label" for="ProcuratorName">Nome</label>
        <input
          type="text"
          class="form-control"
          id="procuratorName"
          name="procuratorName"
          placeholder="Nome"
          v-model="entity.procuratorName"
          :disabled="readOnlyControl('procuratorName') || entity.isHistory"
        />
      </div>
      <div class="col-3">
        <label class="col-form-label" for="procuratorSurname">Cognome</label>
        <input
          type="text"
          class="form-control"
          id="procuratorSurname"
          name="procuratorSurname"
          placeholder="Cognome"
          v-model="entity.procuratorSurname"
          :disabled="readOnlyControl('procuratorSurname') || entity.isHistory"
        />
      </div>
      <div class="col-3">
        <label class="col-form-label" for="procuratorPhone">Telefono</label>
        <input
          type="text"
          class="form-control"
          id="procuratorPhone"
          name="procuratorPhone"
          placeholder="Telefono"
          v-model="entity.procuratorPhone"
          :disabled="readOnlyControl('procuratorPhone') || entity.isHistory"
        />
      </div>
      <div class="col-3">
        <label class="col-form-label" for="procuratorEmail">Email</label>
        <input
          type="text"
          class="form-control"
          id="procuratorEmail"
          name="procuratorEmail"
          placeholder="Email"
          v-model="entity.procuratorEmail"
          :disabled="readOnlyControl('procuratorEmail') || entity.isHistory"
        />
      </div>
      <div class="col-12 mt-5 mb-3" v-if="actionEnable('UploadAttachment')">
        <vue-dropzone
          ref="myVueDropzone"
          id="attachment-dropzone"
          name="attachment-dropzone"
          :options="dropzoneOptions()"
          :useCustomSlot="true"
        >
          <div class="dropzone-custom-content">
            <h3 class="dropzone-custom-title">
              Trascina i file qui per il caricamento
            </h3>
            <div class="subtitle">...o fai click per caricarlo dal tuo pc</div>
          </div>
        </vue-dropzone>
      </div>
    </div>

    <div
      class="row"
      v-if="!$route.params.id || !(isInRole('user') || isInRole('superuser'))"
    >
      <div class="col-12" v-if="!isInRole('customer') && !isInRole('readonly') && !readOnlyControl('save')">
        <div class="form-group mt-3">
          <button
            type="button"
            class="btn btn-xs btn-primary-rgba mr-2"
            v-on:click="save"
            v-if="(!entity.isHistory && entity.state != 'Stopped') || !readOnlyControl('save')"
          >
            Salva
            <font-awesome-icon :icon="['far', 'save']"></font-awesome-icon>
          </button>
          <button
            type="button"
            class="btn btn-xs btn-danger-rgba mr-2"
            v-on:click="loadData"
            v-if="(!entity.isHistory && entity.state != 'Stopped') || !readOnlyControl('save')"
          >
            Annulla
            <font-awesome-icon
              :icon="['far', 'times-circle']"
            ></font-awesome-icon>
          </button>
        </div>

        <div
          class="row"
          v-if="entity.isHistory && entity.attachments.length > 0"
        >
          <div
            class="col-md-3"
            v-for="item in entity.attachments"
            :key="item.attachmentId"
          >
            <div class="card border-light m-b-30">
              <div class="card-header">
                <div class="row align-items-center">
                  <div class="col-9">
                    <span class="badge badge-pill badge-warning">{{
                      item.attachmentType.name
                    }}</span>
                  </div>

                  <div class="col-12">
                    <i
                      class="card-img-top fa-4x text-center p-1"
                      src=""
                      alt="Generic placeholder image"
                      :class="getExtensionIcon(item.fileExtension)"
                    ></i>
                  </div>
                </div>
              </div>

              <div class="card-body">
                <h6 class="cart-title attachment-filename" :title="item.title">
                  <a
                    class="text-primary"
                    href="#"
                    v-on:click.stop="
                      downloadAttachment(
                        item.attachmentId,
                        item.originalFileName
                      )
                    "
                    >{{ item.title }}</a
                  >
                </h6>
                <blockquote class="blockquote">
                  {{ item.description }}
                </blockquote>
                <tags :value="item.tags" />
              </div>
            </div>
          </div>
        </div>

        <hr class="divider" />
        <div
          class="col-12 text-right text-muted"
          v-if="!entity.new && entity.owner != null"
        >
          <small
            >Creato da
            <strong
              >{{ entity.owner.firstName }} {{ entity.owner.lastName }}</strong
            >
            {{ entity.creationDate | formatFullDate }} | Modificato da
            <strong v-if="!entity.new"
              >{{ entity.lastUpdateUser.firstName }}
              {{ entity.lastUpdateUser.lastName }}</strong
            >
            {{ entity.updateDate | formatFullDate }}
          </small>
          <small class="text-success" v-if="entity.draftDate">
            <font-awesome-icon
              class="ml-2"
              :icon="['far', 'check-circle']"
            ></font-awesome-icon>
            Caricamento bozza {{ entity.draftDate | formatFullDate }}</small
          >
        </div>
      </div>

      <!--</form>-->
    </div>
    <a ref="attachmentA"></a>
  </fragment>
</template>
<style scoped>
.document-check {
  font-size: 1.8em;
  vertical-align: middle;
  margin-right: 0.5em;
}
</style>
<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import { Chrome } from "vue-color";
import input from "../../components/Attachments/input.vue";

export default {
  components: { input },
  name: "company",

  props: {
    entity: {
      type: Object,
      required: true,
    },
    operators: {
      type: Array,
      required: true,
    },
    flow: {
      type: Object,
      required: true,
    },
    checkedDocumentation: {
      type: Array,
      required: true,
    },
    attachemntTypes: {
      type: Object,
      required: false,
    },
    documentations: {
      type: Array,
      required: true,
    },
    procedures: {
      type: Array,
      required: true,
    },
    ransoms: {
      type: Array,
      required: true,
    },
    subRansoms: {
      type: Array,
      required: true,
    },
    externalOperators: {
      type: Array,
      required: true,
    },
    outsourcers: { type: Array, required: true },
    regexPattern: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      litigations: [],
      states: [],
      VATS: [],
      companyDetail: false,
      newcheckedDocumentation: [],
      options: [],
      newCost: {
        costId: "",
        description: "",
        amount: 0,
        vatId: "22",
      },
    };
  },
  computed: {
    tinyKey: function () {
      return window.SETTINGS.TinyApiKey;
    },
    cuser() {
      return this.$store.state.user;
    },
    vatlist: function () {
      var me = this;
      if (this.VATS.length == 0) {
        axios.get("contract/vats").then((response) => {
          me.VATS = response.data;
        });
      }
      return this.VATS;
    },
  },
 mounted(){

   this.changeProcedure();
 },
  methods: {
    changeProcedure: function () {

      axios.get("contract/litigation/"+this.entity.companyId).then((response) => this.litigations = response.data);
       if (this.entity.notaryName==null) this.entity.notaryName = "";
        if (this.entity.notarySurname==null)  this.entity.notarySurname = "";
        if (this.entity.notaryOffice==null) this.entity.notaryOffice = "";
        if (this.entity.notaryEmail==null) this.entity.notaryEmail = "";
      if (this.entity.procedureId == "procura") {
        if (this.entity.notaryName == "" || this.entity.notaryName==null) this.entity.notaryName = "Angelo";
        if (this.entity.notarySurname == "" || this.entity.notarySurname==null)  this.entity.notarySurname = "Busani";
        if (this.entity.notaryOffice == "" || this.entity.notaryOffice==null) this.entity.notaryOffice = "Milano";
        if (this.entity.notaryEmail == "" || this.entity.notaryEmail==null) this.entity.notaryEmail = "angelo.busani@notaio-busani.it";
      } else {
        if (
        (this.entity.notaryName.toString() +
            this.entity.notarySurname.toString() +
            this.entity.notaryOffice.toString() +
            this.entity.notaryEmail.toString()).toLowerCase() ==
          "AngeloBusaniMilanoangelo.busani@notaio-busani.it".toLowerCase()
        ) {
          this.entity.notaryName =
            this.entity.notarySurname =
            this.entity.notaryOffice =
            this.entity.notaryEmail =
              "";
        }
      }
    },
    removeAttachmentType: function (id, name) {
      var me = this;
      this.$swal({
        title: `Sicuri di voler rimuovere la richiesta di "${name}"? `,

        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-danger-rgba",
        confirmButtonText: "Procedi",
        cancelButtonText: "Annulla",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          me.checkedDocumentation.splice(
            me.checkedDocumentation.indexOf(id),
            1
          );

          me.newcheckedDocumentation.splice(
            me.newcheckedDocumentation.indexOf(id),
            1
          );
          me.$swal({
            title: "Salvare per rendere le modifiche effettive",
            text: "",
            type: "warning",
            showCancelButton: false,
            toast: true,
            timer: 2000,
            showConfirmButton: false,
            position: "bottom-top",
          });
        }
      });
    },
    dropzoneFileOptions: function (id) {
      var me = this;

      function url() {
        return (
          window.SETTINGS.apiUrl +
          "/attachment/upload/" +
          id +
          "/" +
          me.entity.contractId
        );
      }
      return {
        url: url,
        headers: { Authorization: "Bearer " + this.$store.state.user.token },
        success: function (a, b) {
          this.removeFile(a);
          me.loadData();
        },
      };
    },
    dropzoneOptions: function () {
      var me = this;
      var vm_scope = this;
      function url() {
        return (
          window.SETTINGS.apiUrl +
          "/attachment/upload/documenti-da-validare/" +
          me.entity.contractId
        );
      }
      return {
        url: url,
        headers: { Authorization: "Bearer " + this.$store.state.user.token },

        success: function (a) {
          if (!me.entity.new) {
            this.removeFile(a);
            me.loadData();
          }
          me.$notify({
            text: `<strong>${a.name}</strong> caricato con successo`,
            type: "success",
            data: {
              randomNumber: Math.random(),
            },
          });
        },
      };
    },
    getExtensionIcon: function (ext) {
      if (ext) ext = ext.toLowerCase();
      else ext = "";
      switch (ext) {
        case ".txt":
          return "fa fa-file-text-o";
        case ".doc":
        case ".docx":
          return "fa fa-file-word-o  text-info";
        case ".xls":
        case ".xlsx":
        case ".csv":
          return "fa fa-file-excel-o text-success";
        case ".jpg":
        case ".jpeg":
        case ".png":
        case ".bmp":
        case ".tiff":
          return "fa fa-image  text-info";
        case ".pdf":
          return "fa fa-file-pdf-o text-danger";
        case ".wav":
        case ".mp3":
          return "fa fa-file-audio-o text-warning";
        case ".ppt":
        case ".pptx":
          return "fa fa-file-powerpoint-o text-warning";
        case ".zip":
        case ".rar":
        case ".7z":
          return "fa fa-file-archive-o  text-warning";
        default:
          return "fa fa-file-o";
      }
    },
    addCost: function () {
      var me = this;
      axios.get("contract/newid").then((response) => {
        me.newCost.costId = response.data;

        me.entity.costs.push(JSON.parse(JSON.stringify(me.newCost)));
        me.newCost.description = "";
        me.newCost.amount = 0;
        me.newCost.vatId = "22";
      });
    },

    removeCost: function (id) {
      var me = this;

      var me = this;
      me.$swal({
        title: "Sicuri di voler rimuovere il costo? ",

        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-danger-rgba",
        confirmButtonText: "Procedi",
        cancelButtonText: "Annulla",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          me.entity.costs = me.entity.costs.filter(function (item) {
            return item.costId != id;
          });
        }
      });
    },

    downloadAttachment: function (id, o) {
      var me = this;

      axios
        .get(`attachment/download/${id}`, { responseType: "blob" })
        .then(function (result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(blob, o);
          } else {
            me.$refs.attachmentA.href = URL.createObjectURL(blob);
            me.$refs.attachmentA.download = o;
            me.$refs.attachmentA.click();
          }
        });
    },
    close() {
      this.$emit("close");
    },
    hasAttachment(id) {
      for (var i = 0; i < this.entity.attachments.length; i++) {
        if (this.entity.attachments[i].attachmentTypeId == id) return true;
      }

      return false;
    },
    viewAttachment(id){
var attachments = this.getAttachments(id);
if(attachments.length==1){
    this.downloadAttachment(attachments[0].attachmentId,attachments[0].originalFileName)
}

    },
    getAttachments(id) {
      return this.entity.attachments.filter(x=>x.attachmentTypeId == id);
    },
    numAttachment(id) {
      $("#documenti-da-validare").addClass("d-none");
      var retval = 0;
      for (var i = 0; i < this.entity.attachments.length; i++) {
        if (this.entity.attachments[i].attachmentTypeId == id) retval++;
      }
      $("#documenti-da-validare").html(retval);
      if (retval > 0) $("#documenti-da-validare").removeClass("d-none");
      return retval;
    },
    readOnlyControl(code) {
      if (this.entity.state == "Stopped") return true;
      if (this.isInRole("customer") || this.isInRole("readonly")) return true;
      if (
        (this.isInRole("user") || this.isInRole("superuser")) &&
        !this.entity.new
      ) {
        return true;
      }
      if (this.flow) {
        return (
          this.flow.readOnlyControl.indexOf("*") >= 0 ||
          this.flow.readOnlyControl.indexOf(code) >= 0
        );
      }
      return false;
    },
    isInRole(role) {
      for (var i = 0; i < this.cuser.roles.length; i++) {
        if (this.cuser.roles[i] == role) {
          return true;
        }
      }
      return false;
    },
    readOnlyControlSO(code) {
      if (this.isInRole("superoperator") && this.entity.state != "Stopped")
        return false;

      return this.readOnlyControl(code);
    },
    ransomChange() {
      this.$emit("ransomChange");
    },
    actionEnable(action) {
      if (this.entity && this.entity.state == "Stopped") return false;
      for (let index = 0; index < this.flow.actions.length; index++) {
        var a = this.flow.actions[index];

        if (action.toLowerCase() == a.toLowerCase()) return true;
      }
      return false;
    },
    hideControl(code) {
      if (this.flow) {
        return (
          this.flow.hideControl.indexOf("*") >= 0 ||
          this.flow.hideControl.indexOf(code) >= 0
        );
      }
      return true;
    },
    cancel() {
      this.$router.push({
        name: "route-contract-list",

        replace: true,
      });
    },
    backward() {
      var me = this;
      var state = "";
      var options = {};
      for (let index = 0; index < this.entity.previousStates.length; index++) {
        const element = this.entity.previousStates[index];
        options[element] = this.$filters.contractState(element);
      }
      var rndstring = Math.random().toString(36).substr(2, 6).toUpperCase();
      this.$swal({
        title: `Sicuri di voler retrocedere il contratto?`,
        //html:`Per poter proseguire devi digitare <strong>${rndstring}</strong>`,
        input: "select",
        inputOptions: options,
        customClass: {
          validationMessage: "my-validation-message",
        },
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-danger-rgba",
        confirmButtonText: "Procedi",
        cancelButtonText: "Annulla",

        preConfirm: (value) => {
          // alert(value);
          // if (!value || value!= rndstring) {
          //   me.$swal.showValidationMessage(
          //     'Attenzione, non riconosco la stringa inserita'
          //   )
          //
          state = value;
        },
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          me.$swal({
            title: `Retrocessione contratto a "${me.$filters.contractState(
              state
            )}"`,
            html: `Per poter proseguire devi digitare <strong>${rndstring}</strong>`,
            input: "text",

            customClass: {
              validationMessage: "my-validation-message",
            },
            type: "question",
            showCancelButton: true,
            confirmButtonClass: "btn-danger-rgba",
            confirmButtonText: "Procedi",
            cancelButtonText: "Annulla",

            preConfirm: (value) => {
              if (!value || value != rndstring) {
                me.$swal.showValidationMessage(
                  "Attenzione, non riconosco la stringa inserita"
                );
              }
            },
          }).then(function (isconfirm) {
            if (isconfirm.value) {
              axios
                .post("contract/setstate", {
                  id: me.entity.contractId,
                  state: state,
                })
                .then((response) => {
                  me.loadData();
                });
            }
          });
        }
      });
    },
    stopped() {
      var me = this;
      var rndstring = Math.random().toString(36).substr(2, 6).toUpperCase();
      this.$swal({
        title: `Sicuri di voler revocare il contratto?`,
        html: `Per poter proseguire devi digitare <strong>${rndstring}</strong>`,
        input: "text",

        customClass: {
          validationMessage: "my-validation-message",
        },
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-danger-rgba",
        confirmButtonText: "Procedi",
        cancelButtonText: "Annulla",

        preConfirm: (value) => {
          if (!value || value != rndstring) {
            me.$swal.showValidationMessage(
              "Attenzione, non riconosco la stringa inserita"
            );
          }
        },
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          me.stoppedNote();
        }
      });
    },
    stoppedNote() {
      var me = this;
      var note = "";
      this.$swal({
        title: `Inserire il motivo di revoca`,

        input: "textarea",

        customClass: {
          validationMessage: "my-validation-message",
        },

        showCancelButton: true,
        confirmButtonClass: "btn-danger-rgba",
        confirmButtonText: "Procedi",
        cancelButtonText: "Annulla",

        preConfirm: (value) => {
          if (!value) {
            me.$swal.showValidationMessage(
              "Attenzione inserire il motivo di revoca"
            );
          } else {
            note = value;
          }
        },
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios
            .post("contract/stopped/" + me.entity.contractId, { message: note })
            .then((response) => {
              me.loadData();
            });
        }
      });
    },
    reopen() {
      var me = this;
      var rndstring = Math.random().toString(36).substr(2, 6).toUpperCase();
      this.$swal({
        title: `Sicuri di voler riaprire il contratto?`,
        html: `Per poter proseguire devi digitare <strong>${rndstring}</strong>`,
        input: "text",

        customClass: {
          validationMessage: "my-validation-message",
        },
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-danger-rgba",
        confirmButtonText: "Procedi",
        cancelButtonText: "Annulla",

        preConfirm: (value) => {
          if (!value || value != rndstring) {
            me.$swal.showValidationMessage(
              "Attenzione, non riconosco la stringa inserita"
            );
          }
        },
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios
            .post("contract/reopen/" + me.entity.contractId, {
              message: "prova",
            })
            .then((response) => {
              me.loadData();
            });
        }
      });
    },
    save() {
      let me = this;
      var docs = me.checkedDocumentation.join(",").split(",");
      var ndocs = me.newcheckedDocumentation.join(",").split(",");
      docs = docs.concat(ndocs);

      for(var i in me.entity){
        if(i=='creationDate' || i =='updateDate') continue;
        if(i.toString().toLowerCase().endsWith("date")){
          if(me.entity[i]!=null && me.entity[i].length==0)
          
            me.entity[i] = null;
        }

      }

      me.entity.documentation = docs.join(",");

      axios
        .post(
          `contract/${me.$route.params.cid}/${me.$route.params.id || ""}`,
          this.entity
        )
        .then((response) => {
          if (response.data.error && response.data.code == 200) {
            me.$swal({
              title:
                "Salvataggio avvenuto correttamente, ma controlla i dati inseriti",
              text: "",
              type: "warning",
              showCancelButton: false,
              toast: true,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });
          } else if (response.data.error && response.data.code != 200) {
            me.$swal({
              title: "Impossibile proseguire",
              text: "",
              type: "danger",
              showCancelButton: false,
              toast: true,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });
            me.flow.error = response.data.error;
            me.flow.errors = response.data.errormessages;
            return;
          } else if (!response.data.error) {
            for (var i = 0; i < me.cuser.roles.length; i++) {
              if (me.isInRole("user")) {
                me.$router.push({
                  name: "route-contract-ty",
                });
                return;
              }
            }

            me.$swal({
              title: "Salvataggio avvenuto correttamente",
              text: "",
              type: "success",
              showCancelButton: false,
              toast: true,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });
          }

          if (!me.$route.params.id) {
            me.$router.push({
              name: "route-contract-edit",
              params: { cid: me.entity.companyId, id: me.entity.contractId },
            });
            me.loadData();
          } else {
            me.loadData();
          }
        });
    },
    loadData() {
      this.$emit("loadData");
    },
    verifyCode() {
      var me = this;
      var ransom = "";
      var options = {};
      for (let index = 0; index < this.ransoms.length; index++) {
        const element = this.ransoms[index];
        if (element.related) options[element.ransomId] = element.description;
      }

      axios
        .get(
          `contract/${this.entity.companyId}/${this.entity.contractId}/verify?code=${this.entity.code}`
        )
        .then((response) => {
          if (response.data.code == 500) {
            var parentContract = response.data.data;
            me.$swal({
              //title: `Sicuri di voler retrocedere il contratto?`,
              html: `Attenzione esiste già un contratto con codice  <strong>${parentContract.code}</strong>, selezionare la tipologia riscatto per creare un contratto subordinato `,
              input: "select",
              inputOptions: options,
              customClass: {
                validationMessage: "my-validation-message",
              },
              type: "question",
              showCancelButton: true,
              confirmButtonClass: "btn-danger-rgba",
              confirmButtonText: "Procedi",
              cancelButtonText: "Annulla",

              preConfirm: (value) => {
                ransom = value;
              },
            }).then(function (isconfirm) {
              if (isconfirm.value) {
                axios
                  .post("contract/subordinate", {
                    id: parentContract.contractId,
                    ransom: ransom,
                  })
                  .then((response) => {
                    if (response.data.code == 500) {
                      me.$swal({
                        title: ``,
                        html: response.data.message,
                        type: "danger",
                        showCancelButton: false,
                        confirmButtonClass: "btn-warning-rgba",
                        confirmButtonText: "Annulla",
                      });
                    } else {
                      me.$router.push({
                        name: "route-contract-edit",
                        params: {
                          cid: response.data.data.companyId,
                          id: response.data.data.contractId,
                        },
                      });

                      me.$router.go();
                    }
                  });
              }
            });
          }
        });
    },
    onSearch(search, loading) {
      //  ... do some asynchronous stuff!
      loading(true);
      this.search(loading, search, this);
      //return [{"cap":"43100", "comune":"parma"}];
    },
    search: _.debounce((loading, search, vm) => {
      axios.get(`cap?q=${escape(search)}`).then((res) => {
        vm.options = res.data;
        loading(false);
      });
    }, 350),
  },
};
</script>

<style>
.customdropzone {
  display: inline-block;
  background-color: transparent;
  border: 0;
  height: 40px;
  min-height: 40px;
  padding: 0;
}
.customdropzone .dz-message {
  margin: 0;
  text-align: left;
  font-size: 15px;
}
.customdropzone .dz-preview {
  width: 20px;
  display: inline-block;
}
.customdropzone .dz-preview .dz-image {
  width: 20px;
  height: 20px;
  margin-left: 20px;
  margin-bottom: 10px;
}
.customdropzone .dz-preview .dz-image > div {
  width: inherit;
  height: inherit;

  background-size: contain;
}
.customdropzone .dz-preview .dz-image > img {
  width: 100%;
}

.customdropzone .dz-preview .dz-details {
  color: white;
  transition: opacity 0.2s linear;
  text-align: center;
}
.customdropzone .dz-success-mark,
.dz-error-mark,
.dz-remove {
  display: none;
}

.documenti-inline .dz-preview {
  display: none !important;
}
</style>